import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { WhySection } from './components/WhySection';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1568717437983987');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="nwc23tmizxws">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1568717437983987&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="nur7k407oeyx" />
      </noscript>
      <div className="flex min-h-screen w-full flex-col items-center overflow-x-hidden bg-ice" data-id="element-2" data-mp="34nbhsjeuzx5">
        <main className="w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="3ucjbrrlok7so">
          <Hero data-id="element-4" data-mp="d4xq9hl3gfef" />
          <WhySection data-id="element-5" data-mp="d3cwhu6lt0hm" />
          <SystemOverview data-id="element-6" data-mp="d2l9h7r2ob2y" />
          <Modules data-id="element-7" data-mp="85uihpdqbv2r" />
          <LookInside data-id="element-8" data-mp="85bb32lpgp2z" />
          <Bonuses data-id="element-9" data-mp="86w5ms80s80u" />
          <Differentiators data-id="element-10" data-mp="86cqfj9r7xqi" />
          <Offer data-id="element-11" data-mp="3gleakl2nz7g8" />
          <Guarantee data-id="element-12" data-mp="3gkuxpirvf992" />
          <Testimonials data-id="element-13" data-mp="3gm647qcpav3v" />
          <FAQ data-id="element-14" data-mp="3gja6a20us6ff" />
          <FinalCTA data-id="element-15" data-mp="3gj1vqgs7dd7e" />
          <Footer data-id="element-16" data-mp="3bmtjbb5e3y3x" />
        </main>
      </div>
      <SalesPopup data-id="element-17" data-mp="3bnuvxk220snr" />
    </>;
}